<p-datePicker
  #calendar
  class="w-100"
  appendTo="body"
  iconDisplay="input"
  [inputId]="id()"
  [timeOnly]="true"
  [minDate]="minDate()"
  [maxDate]="maxDate()"
  [hourFormat]="hourFormat()"
  [defaultDate]="defaultDate()"
  [showSeconds]="showSeconds()"
  [showOnFocus]="false"
  [readonlyInput]="readonlyInput()"
  [placeholder]="placeholderSignal()"
  [showIcon]="showIcon()"
  [disabled]="disabled"
  [ngModel]="internalDateValue"
  (ngModelChange)="onDateSelect($event)"
  (onBlur)="onCalendarBlur($event)"
  (onShow)="onCalendarShow($event)"
  (onClose)="onCalendarClose($event)"
  (onFocus)="onCalendarFocus($event)">
  <ng-template let-clickCallBack="clickCallBack" pTemplate="inputicon">
    <em [class]="`icon ${icon()}`" (click)="clickCallBack($event)"></em>
  </ng-template>
</p-datePicker>
